/**
 * Generates the next incremented name based on the provided base name and existing names.
 *
 * @param currentNames - An array of existing names to check against.
 * @param baseName - The base name to use for generating the next incremented name.
 * @param defaultName - The default name to use if no increment is needed.
 * @returns The next incremented name.
 */
export function getNextIncrementedName(currentNames, baseName, defaultName) {
    // Find the last number in the existing names
    const baseNameRegex = new RegExp(`^${baseName} (\\d+)$`);
    let lastNumber;
    for (const name of currentNames) {
        const match = baseNameRegex.exec(name);
        if (match) {
            const number = Number(match[1]);
            if (!Number.isNaN(number) && (lastNumber === undefined || number > lastNumber)) {
                lastNumber = number;
            }
        }
    }
    // If there is a last number, increment it
    if (lastNumber !== undefined) {
        return `${baseName} ${lastNumber + 1}`;
    }
    // If there are existing names, increment the count
    const currentNameCount = currentNames.length;
    if (currentNameCount > 0) {
        return `${baseName} ${currentNameCount + 1}`;
    }
    // Otherwise, return the default name or the base name
    return defaultName ?? baseName;
}
//# sourceMappingURL=getNextIncrementedName.js.map